// extracted by mini-css-extract-plugin
export default {"topCompanies":"topproduct_topCompanies__uopAa","globalUnknonwn":"topproduct_globalUnknonwn__q2DCu"};